import cn from 'classnames';

import type { AuthScheme } from 'api';

export const AuthKeyOption = ({ name, uuid, enabled }: AuthScheme) => (
  <div className="flex items-center justify-between gap-2">
    <div className="min-w-0 leading-loose">
      <div className={cn('truncate', !enabled && 'text-gray-400')}>{name}</div>
      <div className="truncate font-mono text-gray-400">{uuid}</div>
    </div>
    {!enabled && (
      <span className="shrink-0 italic text-feedback-error">Disabled</span>
    )}
  </div>
);
